// nuolino-admin/src/components/ui/use-toast.ts
// Hook público do Toast. Separado de Toast.tsx para fast-refresh limpo.

import { useContext } from 'react';
import { ToastContext } from './ToastContext';
import type { ToastContextValue } from './toast-types';

export { ToastContext } from './ToastContext';

export function useToast(): ToastContextValue {
  const ctx = useContext(ToastContext);
  if (!ctx) throw new Error('useToast must be used within <ToastProvider>');
  return ctx;
}
